import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import FlightSwitch from "./flightSwitch.vue"
import FlightPackages from "./flightPackages.vue";
import FlightDetails from "./flightDetails.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'flightForm',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FlightSwitch),
    _createVNode(FlightPackages),
    _createVNode(FlightDetails)
  ], 64))
}
}

})